import React, { FC } from 'react';
import UsernameControlCommon from '../../../../../components/_UsernameControl';

export interface UsernameControlProps {
  isSubmitting: boolean;
}

const UsernameControl: FC<UsernameControlProps> = ({ isSubmitting }) => (
  <UsernameControlCommon isSubmitting={isSubmitting} />
);

export default UsernameControl;
